// Event queues — zero-allocation, typed, consumed-per-tick.
// Pre-allocated typed arrays with a write head. Cleared every tick.
// Systems write during execution, later systems read, tick.ts clears at start.

const MAX_EVENTS = 64;

// --- Touch events: entity entered/exited a trigger zone ---

export const touchEvents = {
  entityId: new Uint32Array(MAX_EVENTS),
  triggerIdx: new Uint32Array(MAX_EVENTS),
  count: 0,
  push(entity: number, trigger: number) {
    if (this.count >= MAX_EVENTS) return;
    const i = this.count++;
    this.entityId[i] = entity;
    this.triggerIdx[i] = trigger;
  },
  clear() { this.count = 0; },
};

// --- Sim-to-main events (packed into serialization buffer) ---
// These cross the worker→main thread boundary for HUD display.

export const enum SimEventType {
  TIMER_UPDATE = 1,   // data: [playerId, ticks, 0, 0]
  TIMER_STOP = 2,     // data: [playerId, ticks, 0, 0]
  CHECKPOINT = 3,     // data: [playerId, checkpointIdx, 0, 0]
}

export const simEvents = {
  types: new Uint8Array(MAX_EVENTS),
  data: new Int32Array(MAX_EVENTS * 4),
  count: 0,
  push(type: number, d0 = 0, d1 = 0, d2 = 0, d3 = 0) {
    if (this.count >= MAX_EVENTS) return;
    const i = this.count;
    this.types[i] = type;
    const o = i * 4;
    this.data[o] = d0; this.data[o + 1] = d1; this.data[o + 2] = d2; this.data[o + 3] = d3;
    this.count++;
  },
  clear() { this.count = 0; },
};

// --- Audio events (separate queue, packed into serialization buffer) ---
// Dedicated typed fields — no bit-packing, clean structure.

export const enum AudioEventType {
  LAND = 1,
  FOOTSTEP = 2,
}

const MAX_AUDIO_EVENTS = 32;

export const audioEvents = {
  types: new Uint8Array(MAX_AUDIO_EVENTS),
  entityId: new Uint8Array(MAX_AUDIO_EVENTS),
  posX: new Int32Array(MAX_AUDIO_EVENTS),
  posY: new Int32Array(MAX_AUDIO_EVENTS),
  posZ: new Int32Array(MAX_AUDIO_EVENTS),
  material: new Uint8Array(MAX_AUDIO_EVENTS),
  count: 0,
  push(type: number, entity: number, px: number, py: number, pz: number, mat: number) {
    if (this.count >= MAX_AUDIO_EVENTS) return;
    const i = this.count++;
    this.types[i] = type;
    this.entityId[i] = entity;
    this.posX[i] = px;
    this.posY[i] = py;
    this.posZ[i] = pz;
    this.material[i] = mat;
  },
  clear() { this.count = 0; },
};
